import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import tema from './theme';
import LoginPagina from './pages/login/login_pagina';
import CadastroPagina from './pages/login/cadastro_pagina';
import PainelPagina from './pages/inicio/painel_pagina';
import CasoDetalhePagina from './pages/inicio/caso_detalhe_pagina';
import AvaliacaoPagina from './pages/inicio/avaliacao_pagina';
import GerenciamentoHubPagina from './pages/inicio/gerenciamento_hub_pagina';
import ModulosGerenciamentoPagina from './pages/modulos/modulos_gerenciamento_pagina';
import ModuloCriarPagina from './pages/modulos/modulo_criar_pagina';
import ModuloDetalhePagina from './pages/modulos/modulo_detalhe_pagina';
import TurmasGerenciamentoPagina from './pages/turmas/turmas_gerenciamento_pagina';
import TurmaCriarPagina from './pages/turmas/turma_criar_pagina';
import ProfessoresGerenciamentoPagina from './pages/professor/professores_gerenciamento_pagina';
import ProfessorCriarPagina from './pages/professor/professor_criar_pagina';
import ProfessorEditarPagina from './pages/professor/professor_editar_pagina';
import TurmaDetalhePagina from './pages/turmas/turma_detalhe_pagina';
import ModuloEditarPagina from './pages/modulos/modulo_editar_pagina';
import TurmaEditarPagina from './pages/turmas/turma_editar_pagina';
import CasosGerenciamentoPagina from './pages/casos/casos_gerenciamento_pagina';
import CasoCriarPagina from './pages/casos/caso_criar_pagina';
import CasoDetalheAdminPagina from './pages/casos/caso_detalhe_admin_pagina';
import CriteriosGerenciamentoPagina from './pages/criterios/criterios_gerenciamento_pagina';
import CasoEditarPagina from './pages/casos/caso_editar_pagina';
import OpcoesRespostaGerenciamentoPagina from './pages/respostas/opcoes_resposta_gerenciamento_pagina';
import GrupoDetalhePagina from './pages/turmas/grupo_detalhe_pagina';
import TurmaPainelPagina from './pages/inicio/turma_painel_pagina';
import RelatorioGrupoPagina from './pages/inicio/relatorio_grupo_pagina';


import RotaProtegida from './components/rota_protegida';
import LayoutPrincipal from './components/layout_principal';
import PerfilPagina from './perfil/perfil_pagina';

function App() {
  return (
    <ThemeProvider theme={tema}>
      <CssBaseline />
      <Router>
        <Routes>
          {/* ROTAS PÚBLICAS */}
          <Route path="/login" element={<LoginPagina />} />
          <Route path="/cadastro" element={<CadastroPagina />} />

          {/* ROTAS PROTEGIDAS*/}
          <Route
            path="/"
            element={<RotaProtegida><LayoutPrincipal><PainelPagina /></LayoutPrincipal></RotaProtegida>}
          />
          <Route
            path="/grupos/:grupoId/casos/:casoId"
            element={<RotaProtegida><LayoutPrincipal><CasoDetalhePagina /></LayoutPrincipal></RotaProtegida>} />
          <Route
            path="/avaliar/turma/:turmaId/grupo/:grupoId/aluno/:alunoId/caso/:casoId"
            element={<RotaProtegida><LayoutPrincipal><AvaliacaoPagina /></LayoutPrincipal></RotaProtegida>}
          />
          <Route
            path="/gerenciar"
            element={<RotaProtegida><LayoutPrincipal><GerenciamentoHubPagina /></LayoutPrincipal></RotaProtegida>}
          />
          <Route
            path="/gerenciar-modulos"
            element={<RotaProtegida><LayoutPrincipal><ModulosGerenciamentoPagina /></LayoutPrincipal></RotaProtegida>}
          />
          <Route
            path="/modulos/criar"
            element={<RotaProtegida><LayoutPrincipal><ModuloCriarPagina /></LayoutPrincipal></RotaProtegida>}
          />
          <Route
            path="/modulos/:id"
            element={<RotaProtegida><LayoutPrincipal><ModuloDetalhePagina /></LayoutPrincipal></RotaProtegida>}
          />
          <Route
            path="/gerenciar-turmas"
            element={<RotaProtegida><LayoutPrincipal><TurmasGerenciamentoPagina /></LayoutPrincipal></RotaProtegida>}
          />
          <Route
            path="/turmas/criar"
            element={<RotaProtegida><LayoutPrincipal><TurmaCriarPagina /></LayoutPrincipal></RotaProtegida>}
          />
          <Route
            path="/gerenciar-professores"
            element={<RotaProtegida><LayoutPrincipal><ProfessoresGerenciamentoPagina /></LayoutPrincipal></RotaProtegida>}
          />
          <Route
            path="/professores/criar"
            element={<RotaProtegida><LayoutPrincipal><ProfessorCriarPagina /></LayoutPrincipal></RotaProtegida>}
          />
          <Route
            path="/professores/editar/:id"
            element={<RotaProtegida><LayoutPrincipal><ProfessorEditarPagina /></LayoutPrincipal></RotaProtegida>}
          />
          <Route
            path="/turmas/:id"
            element={<RotaProtegida><LayoutPrincipal><TurmaDetalhePagina /></LayoutPrincipal></RotaProtegida>}
          />
          <Route
            path="/modulos/editar/:id"
            element={<RotaProtegida><LayoutPrincipal><ModuloEditarPagina /></LayoutPrincipal></RotaProtegida>}
          />
          <Route
            path="/turmas/editar/:id"
            element={<RotaProtegida><LayoutPrincipal><TurmaEditarPagina /></LayoutPrincipal></RotaProtegida>}
          />
          <Route
            path="/gerenciar-casos"
            element={<RotaProtegida><LayoutPrincipal><CasosGerenciamentoPagina /></LayoutPrincipal></RotaProtegida>}
          />
          <Route
            path="/casos/criar"
            element={<RotaProtegida><LayoutPrincipal><CasoCriarPagina /></LayoutPrincipal></RotaProtegida>}
          />
          <Route
            path="/casos/detalhes/:id"
            element={<RotaProtegida><LayoutPrincipal><CasoDetalheAdminPagina /></LayoutPrincipal></RotaProtegida>}
          />
          <Route
            path="/gerenciar-criterios"
            element={<RotaProtegida><LayoutPrincipal><CriteriosGerenciamentoPagina /></LayoutPrincipal></RotaProtegida>}
          />
          <Route
            path="/casos/editar/:id"
            element={<RotaProtegida><LayoutPrincipal><CasoEditarPagina /></LayoutPrincipal></RotaProtegida>}
          />
          <Route
            path="/gerenciar-opcoes-resposta"
            element={<RotaProtegida><LayoutPrincipal><OpcoesRespostaGerenciamentoPagina /></LayoutPrincipal></RotaProtegida>}
          />
          <Route
            path="/grupos/:id"
            element={<RotaProtegida><LayoutPrincipal><GrupoDetalhePagina /></LayoutPrincipal></RotaProtegida>}
          />
          <Route
            path="/avaliacoes/editar/:avaliacaoId"
            element={<RotaProtegida><LayoutPrincipal><AvaliacaoPagina /></LayoutPrincipal></RotaProtegida>}
          />
          <Route
            path="/minha-turma/:id"
            element={<RotaProtegida><LayoutPrincipal><TurmaPainelPagina /></LayoutPrincipal></RotaProtegida>}
          />
          <Route
            path="/relatorios/grupo/:grupoId"
            element={<RotaProtegida><LayoutPrincipal><RelatorioGrupoPagina /></LayoutPrincipal></RotaProtegida>}
          />
          <Route
            path="/meu-perfil"
            element={<RotaProtegida><LayoutPrincipal><PerfilPagina /></LayoutPrincipal></RotaProtegida>} />
        </Routes>
      </Router>
    </ThemeProvider>
  );
}

export default App;